<script lang="ts" setup>
import UserProjectList from '@/components/UserProjectList.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
</script>

<template>
  <div>
    <h1><font-awesome-icon :icon="['fas', 'list']" /> Projects</h1>
    <h5>Upload FASTQs, analyze and inspect results</h5>
    <hr />
    <p>
      The <strong>Projects</strong> view offers a seamless way to browse all
      your projects. You can upload data files in FASTQ format, with the option
      to upload compressed gzip files to save network bandwidth. You can manage
      and browse your files, initiate data analyses, and inspect the results
      directly within the platform. Premium users gain access to advanced
      analysis features, enhancing the research capabilities. All computations
      are performed using our cloud computational infrastructure, ensuring
      efficient and reliable processing of data.
    </p>
    <!-- Include the ProjectList component -->
    <UserProjectList />
  </div>
</template>

<style scoped></style>
